//#region src/tokens/breakpoints.ts
/**
* Breakpoints in px, for every brand (question L5): tablet, desktop and the widest
* workspace. This file is the single source: scripts/build-breakpoints.ts generates the
* CSS custom media in custom-media.css from it, and a test fails if that file is stale.
*
* - `sm` 768: tablet. Page titles step down below it.
* - `md` 1024: desktop. The sidebar is persistent from here up; below it, a menu drawer.
* - `lg` 1440: the widest app workspace (`--workspace-max`).
*/
var breakpoints = {
	sm: 768,
	md: 1024,
	lg: 1440
};
/** The breakpoints from smallest to largest. */
var breakpointOrder = Object.keys(breakpoints);
/**
* Media queries for each breakpoint, for `matchMedia` and `useMediaQuery`. They are the
* same queries as the CSS custom media: `up.md` is `@media (--md-up)`, `below.md` is
* `@media (--below-md)`.
*/
var mediaQueries = {
	up: Object.fromEntries(breakpointOrder.map((name) => [name, `(width >= ${breakpoints[name]}px)`])),
	below: Object.fromEntries(breakpointOrder.map((name) => [name, `(width < ${breakpoints[name]}px)`]))
};
//#endregion
export { breakpointOrder, breakpoints, mediaQueries };

//# sourceMappingURL=breakpoints.js.map